export var version = {
  'lib': '1.2537.57',
  'product': '1.2537.57',
  'supportedApiVersion': 2
};



/** WEBPACK FOOTER **
 ** ./src/misc/Version.ts
 **/